<template>
  <div class="about text-center">
    <h4>About</h4>
    <hr/>
    <h1>
      Data Visualization
    </h1>
    <h2>
      Project
    </h2>
    <h5>UNamur 2018</h5>
    <p>Université de Namur &mdash;
      <a href="https://formation-continue.unamur.be/data-science" target="_blank">
        Certificat d’université d’Executive Master en data science
      </a>
    </p>
    <hr/>
    <h5>Group {{ group }}</h5>
    <ul class="no-bullet">
      <li v-for="student in students" :key="student.id">
        {{ student.firstname }} <B>{{ student.lastname }}</B>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      group: 11,
      students: [
        {
          id: 1,
          firstname: 'Marc',
          lastname: 'Eloy',
        },
        {
          id: 2,
          firstname: 'Thibaut',
          lastname: 'Goelff',
        },
        {
          id: 3,
          firstname: 'Dieudonné',
          lastname: 'Yamma',
        },
      ],
    };
  },
};
</script>
